module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-container"
  }, [_c('div', {
    staticClass: "toolbar-header",
    staticStyle: {
      "width": "100vw",
      "z-index": "99"
    }
  }, [_c('p', {
    staticClass: "mar-text",
    staticStyle: {
      "font-family": "'DINPro Bold'"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'landing'
        })
      }
    }
  }, [_vm._v("Mar of "), _c('br'), _vm._v(" Santa Barbara")]), _vm._v(" "), (_vm.$store.state.currentFilter != 'Catagories') ? _c('p', {
    staticStyle: {
      "font-family": "'DINPro Regular",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$store.state.currentFilter))]) : _c('p', {
    staticStyle: {
      "font-family": "'DINPro Regular",
      "text-align": "center"
    }
  }, [_vm._v("Collections")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df2b0ce6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/CollectionContainer.vue
// module id = 225
// module chunks = 1